import { Typography } from '@mui/material';

export const Price = ({
  text,
  className,
  id
}: {
  text: string;
  className?: string;
  id?: string;
}) => {
  return (
    <Typography variant="bodyMDRegular" className={className} id={id}>
      {text}
    </Typography>
  );
};
